import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGlassCheers,
  faPlusCircle,
  faBars,
  faSignOutAlt,
  faTrashAlt,
  faEdit,
  faListUl,
  faChevronRight,
  faChevronLeft,
  faStar,
  faStarHalfAlt
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faGlassCheers,
  faPlusCircle,
  faBars,
  faSignOutAlt,
  faTrashAlt,
  faEdit,
  faListUl,
  faChevronRight,
  faChevronLeft,
  faStar,
  faStarHalfAlt
);
